const DEFAULT_CDN_URL = 'https://cdn-dev.culturemap.app';

const normaliseBaseUrl = (value?: string | null): string => {
  if (!value) {
    return DEFAULT_CDN_URL;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return DEFAULT_CDN_URL;
  }

  const withoutTrailingSlash = trimmed.replace(/\s+/g, '').replace(/\/+$/, '');

  try {
    const url = new URL(withoutTrailingSlash);
    return url.origin;
  } catch {
    try {
      const coerced = new URL(`https://${withoutTrailingSlash.replace(/^https?:\/\//, '')}`);
      return coerced.origin;
    } catch {
      return DEFAULT_CDN_URL;
    }
  }
};

const CDN_BASE_URL = normaliseBaseUrl(
  typeof process !== 'undefined' ? process.env.REACT_APP_CLOUDFRONT_URL : undefined
);

export const getEnvCdnBaseUrl = (): string => CDN_BASE_URL;

export const getEnvCdnHostname = (): string => {
  try {
    return new URL(CDN_BASE_URL).hostname;
  } catch {
    return 'cdn-dev.culturemap.app';
  }
};

export const isEnvCdnUrl = (value?: string | null): boolean => {
  if (!value) {
    return false;
  }

  const hostname = getEnvCdnHostname();

  try {
    return new URL(value).hostname === hostname;
  } catch {
    return value.includes(hostname);
  }
};

export const buildEnvCdnUrl = (path: string): string => {
  const normalisedPath = path.replace(/^\/*/, '');
  return `${getEnvCdnBaseUrl()}/${normalisedPath}`;
};

// Legacy aliases for existing imports
export const getCdnBaseUrl = getEnvCdnBaseUrl;
export const getCdnHostname = getEnvCdnHostname;
export const isCdnUrl = isEnvCdnUrl;
export const buildCdnUrl = buildEnvCdnUrl;


